import { render, staticRenderFns } from "./RateSetting.vue?vue&type=template&id=9acb51dc&scoped=true"
import script from "./RateSetting.vue?vue&type=script&lang=js"
export * from "./RateSetting.vue?vue&type=script&lang=js"
import style0 from "./RateSetting.vue?vue&type=style&index=0&id=9acb51dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9acb51dc",
  null
  
)

export default component.exports